

// import React, { useState, useEffect } from "react";
// import { useHistory } from "react-router-dom";
// import { getDatabase, ref, get } from "firebase/database";
// import {
//   getAuth,
//   signInWithEmailAndPassword,
//   sendPasswordResetEmail,
//   verifyPasswordResetCode,
//   confirmPasswordReset,
// } from "firebase/auth";
// import { toast, Toaster } from "react-hot-toast";
// import { app } from "../Firebase/firebase.config";

// const auth = getAuth(app);
// const fireDB = getDatabase(app);

// const DrLogin = () => {
//   const history = useHistory();
//   const [user, setUser] = useState({ Mobile: "", Password: "" });
//   const [focusedField, setFocusedField] = useState(null);
//   const [loading, setLoading] = useState(false);

//   // ── Forgot Password state ──────────────────────────────────────────────
//   const [showForgot, setShowForgot] = useState(false);
//   const [forgotMobile, setForgotMobile] = useState("");
//   const [forgotFocused, setForgotFocused] = useState(false);
//   const [forgotLoading, setForgotLoading] = useState(false);
//   const [forgotSent, setForgotSent] = useState(false);

//   // ── Reset-completion state (when user arrives via the emailed link) ────
//   const [resetMode, setResetMode] = useState(false);
//   const [resetCode, setResetCode] = useState(null);
//   const [resetEmail, setResetEmail] = useState("");
//   const [newPassword, setNewPassword] = useState("");
//   const [confirmNewPassword, setConfirmNewPassword] = useState("");
//   const [resetVerifying, setResetVerifying] = useState(true);
//   const [resetSubmitting, setResetSubmitting] = useState(false);
//   const [resetError, setResetError] = useState("");
//   const [resetDone, setResetDone] = useState(false);

//   // Detect ?mode=resetPassword&oobCode=... on page load
//   useEffect(() => {
//     const params = new URLSearchParams(window.location.search);
//     const mode = params.get("mode");
//     const oobCode = params.get("oobCode");

//     if (mode === "resetPassword" && oobCode) {
//       setResetMode(true);
//       verifyPasswordResetCode(auth, oobCode)
//         .then((email) => {
//           setResetCode(oobCode);
//           setResetEmail(email);
//           setResetVerifying(false);
//         })
//         .catch(() => {
//           setResetError(
//             "This reset link is invalid or has expired. Please request a new one."
//           );
//           setResetVerifying(false);
//         });
//     } else {
//       setResetVerifying(false);
//     }
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setUser((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     const { Mobile, Password } = user;

//     if (!Mobile || !Password) {
//       toast.error("Mobile and Password required");
//       return;
//     }
//     if (!/^\d{10}$/.test(Mobile)) {
//       toast.error("Invalid Mobile number");
//       return;
//     }

//     setLoading(true);
//     try {
//       const snapshot = await get(ref(fireDB, "doctor"));
//       if (!snapshot.exists()) {
//         toast.error("No doctors found");
//         setLoading(false);
//         return;
//       }

//       let doctorFound = null;
//       snapshot.forEach((doc) => {
//         const data = doc.val();
//         if (data.Mobile === Mobile) {
//           doctorFound = { ...data, uid: doc.key };
//         }
//       });

//       if (!doctorFound) {
//         toast.error("Mobile not registered");
//         setLoading(false);
//         return;
//       }

//       await signInWithEmailAndPassword(auth, doctorFound.Email, Password);
//       toast.success("Login successful!");
//       history.replace(`/profile/${doctorFound.uid}`);
//     } catch (error) {
//       console.error(error);
//       toast.error("Incorrect Mobile or Password");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ── Forgot Password handler ────────────────────────────────────────────
//   // Looks up the doctor's registered email via Mobile number, then asks
//   // Firebase Auth to send a password-reset link to that email, pointed
//   // back at THIS app (instead of Firebase's default hosted page) via
//   // actionCodeSettings.
//   const handleForgotPassword = async (e) => {
//     e.preventDefault();

//     if (!forgotMobile) {
//       toast.error("Please enter your registered mobile number");
//       return;
//     }
//     if (!/^\d{10}$/.test(forgotMobile)) {
//       toast.error("Invalid Mobile number");
//       return;
//     }

//     setForgotLoading(true);
//     try {
//       const snapshot = await get(ref(fireDB, "doctor"));
//       let doctorFound = null;

//       if (snapshot.exists()) {
//         snapshot.forEach((doc) => {
//           const data = doc.val();
//           if (data.Mobile === forgotMobile) {
//             doctorFound = { ...data, uid: doc.key };
//           }
//         });
//       }

//       console.log("forgotMobile entered:", forgotMobile);
//       console.log("doctorFound:", doctorFound);

//       // Always show the same success state whether or not the mobile
//       // number exists, so we don't reveal which numbers are registered.
//       if (doctorFound?.Email) {
//         const actionCodeSettings = {
//           url: `${window.location.origin}/doctor-login`,
//           handleCodeInApp: true,
//         };
//         // NOTE: actionCodeSettings must be passed as the 3rd argument,
//         // otherwise Firebase falls back to its default firebaseapp.com
//         // hosted page instead of redirecting back to this app.
//         await sendPasswordResetEmail(auth, doctorFound.Email, actionCodeSettings);
//       }

//       setForgotSent(true);
//       toast.success(
//         "If that mobile is registered, a reset link has been sent to the linked email."
//       );
//     } catch (error) {
//       console.error(error);
//       // Even on unexpected errors, avoid leaking account existence.
//       setForgotSent(true);
//       toast.success(
//         "If that mobile is registered, a reset link has been sent to the linked email."
//       );
//     } finally {
//       setForgotLoading(false);
//     }
//   };

//   // ── Reset-completion handler ───────────────────────────────────────────
//   // Called from the "set new password" form shown when the user arrives
//   // via the emailed link (resetMode === true).
//   const handleResetSubmit = async (e) => {
//     e.preventDefault();

//     if (!newPassword || !confirmNewPassword) {
//       toast.error("Please fill in both password fields");
//       return;
//     }
//     if (newPassword.length < 6) {
//       toast.error("Password must be at least 6 characters");
//       return;
//     }
//     if (newPassword !== confirmNewPassword) {
//       toast.error("Passwords do not match");
//       return;
//     }

//     setResetSubmitting(true);
//     try {
//       await confirmPasswordReset(auth, resetCode, newPassword);
//       setResetDone(true);
//       toast.success("Password reset successfully! You can now log in.");
//     } catch (error) {
//       console.error(error);
//       toast.error("Failed to reset password. The link may have expired.");
//     } finally {
//       setResetSubmitting(false);
//     }
//   };

//   const openForgot = () => {
//     setShowForgot(true);
//     setForgotSent(false);
//     setForgotMobile("");
//   };

//   const closeForgot = () => {
//     setShowForgot(false);
//     setForgotSent(false);
//     setForgotMobile("");
//   };

//   const styles = {
//     page: {
//       minHeight: "100vh",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       background: "linear-gradient(135deg, #e0f2fe 0%, #bae6fd 40%, #e0f7fa 100%)",
//       fontFamily: "'Nunito', 'Segoe UI', sans-serif",
//       padding: "16px",
//     },
//     card: {
//       width: "100%",
//       maxWidth: "420px",
//       background: "rgba(255,255,255,0.85)",
//       backdropFilter: "blur(16px)",
//       borderRadius: "24px",
//       boxShadow: "0 8px 40px rgba(14, 116, 144, 0.13), 0 2px 8px rgba(14,116,144,0.07)",
//       padding: "40px 32px 36px",
//       border: "1px solid rgba(186,230,253,0.6)",
//     },
//     iconWrap: {
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       marginBottom: "20px",
//     },
//     iconCircle: {
//       width: "64px",
//       height: "64px",
//       borderRadius: "50%",
//       background: "linear-gradient(135deg, #0ea5e9 0%, #38bdf8 100%)",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       boxShadow: "0 4px 16px rgba(14,165,233,0.30)",
//     },
//     title: {
//       textAlign: "center",
//       fontSize: "26px",
//       fontWeight: "800",
//       color: "#0c4a6e",
//       margin: "0 0 4px",
//       letterSpacing: "-0.5px",
//     },
//     subtitle: {
//       textAlign: "center",
//       fontSize: "14px",
//       color: "#7dd3fc",
//       marginBottom: "28px",
//       fontWeight: "600",
//       letterSpacing: "0.5px",
//       textTransform: "uppercase",
//     },
//     fieldGroup: {
//       marginBottom: "18px",
//     },
//     label: {
//       display: "block",
//       fontSize: "13px",
//       fontWeight: "700",
//       color: "#0369a1",
//       marginBottom: "7px",
//       letterSpacing: "0.3px",
//     },
//     inputWrap: {
//       position: "relative",
//       display: "flex",
//       alignItems: "center",
//     },
//     inputIcon: {
//       position: "absolute",
//       left: "14px",
//       top: "50%",
//       transform: "translateY(-50%)",
//       pointerEvents: "none",
//       display: "flex",
//       alignItems: "center",
//     },
//     input: (focused) => ({
//       width: "100%",
//       padding: "13px 14px 13px 44px",
//       border: focused
//         ? "2px solid #0ea5e9"
//         : "2px solid #e0f2fe",
//       borderRadius: "12px",
//       fontSize: "15px",
//       fontFamily: "'Nunito', 'Segoe UI', sans-serif",
//       fontWeight: "600",
//       color: "#0c4a6e",
//       background: focused ? "#f0f9ff" : "#f8fdff",
//       outline: "none",
//       transition: "border 0.2s, background 0.2s, box-shadow 0.2s",
//       boxShadow: focused ? "0 0 0 3px rgba(14,165,233,0.13)" : "none",
//       boxSizing: "border-box",
//     }),
//     button: {
//       width: "100%",
//       padding: "14px",
//       background: loading
//         ? "#7dd3fc"
//         : "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
//       color: "#fff",
//       border: "none",
//       borderRadius: "12px",
//       fontSize: "16px",
//       fontWeight: "800",
//       fontFamily: "'Nunito', 'Segoe UI', sans-serif",
//       cursor: loading ? "not-allowed" : "pointer",
//       boxShadow: "0 4px 16px rgba(14,165,233,0.30)",
//       letterSpacing: "0.3px",
//       marginTop: "6px",
//       transition: "background 0.2s, transform 0.1s",
//     },
//     forgotLink: {
//       display: "block",
//       textAlign: "right",
//       fontSize: "12.5px",
//       fontWeight: "700",
//       color: "#0ea5e9",
//       background: "none",
//       border: "none",
//       cursor: "pointer",
//       padding: "0 0 14px",
//       marginTop: "-8px",
//       letterSpacing: "0.2px",
//     },
//     divider: {
//       textAlign: "center",
//       margin: "22px 0 14px",
//       position: "relative",
//     },
//     dividerLine: {
//       borderTop: "1px solid #e0f2fe",
//       width: "100%",
//       position: "absolute",
//       top: "50%",
//       left: 0,
//     },
//     dividerText: {
//       position: "relative",
//       background: "rgba(255,255,255,0.85)",
//       padding: "0 12px",
//       color: "#93c5fd",
//       fontSize: "12px",
//       fontWeight: "700",
//     },
//     registerBtn: {
//       display: "block",
//       width: "100%",
//       padding: "13px",
//       background: "transparent",
//       border: "2px solid #bae6fd",
//       borderRadius: "12px",
//       color: "#0284c7",
//       fontSize: "15px",
//       fontWeight: "700",
//       fontFamily: "'Nunito', 'Segoe UI', sans-serif",
//       cursor: "pointer",
//       textAlign: "center",
//       transition: "background 0.2s, border-color 0.2s",
//       letterSpacing: "0.2px",
//     },
//     footer: {
//       textAlign: "center",
//       marginTop: "24px",
//       fontSize: "12px",
//       color: "#93c5fd",
//       fontWeight: "600",
//     },
//     // ── Forgot Password panel ──
//     forgotOverlay: {
//       position: "fixed",
//       top: 0, left: 0, right: 0, bottom: 0,
//       background: "rgba(12, 74, 110, 0.45)",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       padding: "16px",
//       zIndex: 1000,
//     },
//     forgotCard: {
//       width: "100%",
//       maxWidth: "380px",
//       background: "#ffffff",
//       borderRadius: "20px",
//       boxShadow: "0 12px 48px rgba(14, 116, 144, 0.25)",
//       padding: "30px 26px 26px",
//       border: "1px solid rgba(186,230,253,0.6)",
//     },
//     forgotHeader: {
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "space-between",
//       marginBottom: "6px",
//     },
//     forgotTitle: {
//       fontSize: "19px",
//       fontWeight: "800",
//       color: "#0c4a6e",
//       margin: 0,
//     },
//     forgotClose: {
//       background: "#f0f9ff",
//       border: "none",
//       borderRadius: "8px",
//       width: "30px",
//       height: "30px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       cursor: "pointer",
//       color: "#0369a1",
//       fontSize: "16px",
//       lineHeight: 1,
//     },
//     forgotDesc: {
//       fontSize: "13px",
//       color: "#64748b",
//       margin: "0 0 20px",
//       lineHeight: 1.5,
//     },
//     forgotSubmitBtn: {
//       width: "100%",
//       padding: "13px",
//       background: forgotLoading
//         ? "#7dd3fc"
//         : "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
//       color: "#fff",
//       border: "none",
//       borderRadius: "12px",
//       fontSize: "15px",
//       fontWeight: "800",
//       fontFamily: "'Nunito', 'Segoe UI', sans-serif",
//       cursor: forgotLoading ? "not-allowed" : "pointer",
//       boxShadow: "0 4px 16px rgba(14,165,233,0.30)",
//       marginTop: "4px",
//     },
//     forgotSuccessWrap: {
//       textAlign: "center",
//       padding: "8px 0 4px",
//     },
//     forgotSuccessIcon: {
//       width: "56px",
//       height: "56px",
//       borderRadius: "50%",
//       background: "#dcfce7",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       margin: "0 auto 14px",
//     },
//     forgotSuccessText: {
//       fontSize: "14px",
//       color: "#334155",
//       lineHeight: 1.6,
//       margin: "0 0 20px",
//     },
//     forgotDoneBtn: {
//       width: "100%",
//       padding: "12px",
//       background: "#f0f9ff",
//       border: "2px solid #bae6fd",
//       borderRadius: "12px",
//       color: "#0284c7",
//       fontSize: "14px",
//       fontWeight: "700",
//       cursor: "pointer",
//     },
//   };

//   // ── If the user arrived via the password-reset email link, show the
//   // "set new password" screen instead of the normal login form. ─────────
//   if (resetMode) {
//     return (
//       <div style={styles.page}>
//         <Toaster
//           position="top-center"
//           toastOptions={{
//             style: {
//               fontFamily: "'Nunito', sans-serif",
//               fontWeight: "700",
//               borderRadius: "12px",
//               fontSize: "14px",
//             },
//           }}
//         />
//         <div style={styles.card}>
//           <div style={styles.iconWrap}>
//             <div style={styles.iconCircle}>
//               <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
//                 <rect x="5" y="11" width="14" height="10" rx="2" stroke="white" strokeWidth="2"/>
//                 <path d="M8 11V7a4 4 0 0 1 8 0v4" stroke="white" strokeWidth="2" strokeLinecap="round"/>
//                 <circle cx="12" cy="16" r="1.5" fill="white"/>
//               </svg>
//             </div>
//           </div>

//           <h2 style={styles.title}>Reset Password</h2>
//           <p style={styles.subtitle}>Trusted Medical Portal</p>

//           {resetVerifying ? (
//             <p style={{ textAlign: "center", color: "#64748b" }}>
//               Verifying your reset link…
//             </p>
//           ) : resetError ? (
//             <>
//               <p style={{ textAlign: "center", color: "#dc2626", marginBottom: 20, lineHeight: 1.6 }}>
//                 {resetError}
//               </p>
//               <button
//                 style={styles.registerBtn}
//                 onClick={() => history.push("/doctor-login")}
//               >
//                 Back to Login
//               </button>
//             </>
//           ) : resetDone ? (
//             <div style={styles.forgotSuccessWrap}>
//               <div style={styles.forgotSuccessIcon}>
//                 <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
//                   <path d="M5 13l4 4L19 7" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
//                 </svg>
//               </div>
//               <p style={styles.forgotSuccessText}>
//                 Your password has been reset successfully. You can now log
//                 in with your new password.
//               </p>
//               <button
//                 style={styles.forgotDoneBtn}
//                 onClick={() => history.push("/doctor-login")}
//               >
//                 Go to Login
//               </button>
//             </div>
//           ) : (
//             <form onSubmit={handleResetSubmit}>
//               <p
//                 style={{
//                   textAlign: "center",
//                   fontSize: 13,
//                   color: "#64748b",
//                   marginBottom: 18,
//                   lineHeight: 1.5,
//                 }}
//               >
//                 Resetting password for <strong>{resetEmail}</strong>
//               </p>

//               <div style={styles.fieldGroup}>
//                 <label style={styles.label} htmlFor="new-password-input">
//                   New Password
//                 </label>
//                 <div style={styles.inputWrap}>
//                   <span style={styles.inputIcon}>
//                     <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
//                       <rect x="5" y="11" width="14" height="10" rx="2" stroke="#38bdf8" strokeWidth="2"/>
//                       <path d="M8 11V7a4 4 0 0 1 8 0v4" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round"/>
//                       <circle cx="12" cy="16" r="1.5" fill="#38bdf8"/>
//                     </svg>
//                   </span>
//                   <input
//                     id="new-password-input"
//                     type="password"
//                     value={newPassword}
//                     onChange={(e) => setNewPassword(e.target.value)}
//                     placeholder="Enter new password"
//                     style={styles.input(false)}
//                   />
//                 </div>
//               </div>

//               <div style={styles.fieldGroup}>
//                 <label style={styles.label} htmlFor="confirm-password-input">
//                   Confirm Password
//                 </label>
//                 <div style={styles.inputWrap}>
//                   <span style={styles.inputIcon}>
//                     <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
//                       <rect x="5" y="11" width="14" height="10" rx="2" stroke="#38bdf8" strokeWidth="2"/>
//                       <path d="M8 11V7a4 4 0 0 1 8 0v4" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round"/>
//                       <circle cx="12" cy="16" r="1.5" fill="#38bdf8"/>
//                     </svg>
//                   </span>
//                   <input
//                     id="confirm-password-input"
//                     type="password"
//                     value={confirmNewPassword}
//                     onChange={(e) => setConfirmNewPassword(e.target.value)}
//                     placeholder="Confirm new password"
//                     style={styles.input(false)}
//                   />
//                 </div>
//               </div>

//               <button type="submit" disabled={resetSubmitting} style={styles.button}>
//                 {resetSubmitting ? "Resetting…" : "Reset Password"}
//               </button>
//             </form>
//           )}
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div style={styles.page}>
//       <Toaster
//         position="top-center"
//         toastOptions={{
//           style: {
//             fontFamily: "'Nunito', sans-serif",
//             fontWeight: "700",
//             borderRadius: "12px",
//             fontSize: "14px",
//           },
//         }}
//       />

//       <div style={styles.card}>
//         {/* Icon */}
//         <div style={styles.iconWrap}>
//           <div style={styles.iconCircle}>
//             <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
//               <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" fill="white"/>
//               <path d="M3 21C3 17.134 7.02944 14 12 14C16.9706 14 21 17.134 21 21" stroke="white" strokeWidth="2" strokeLinecap="round"/>
//               <circle cx="18.5" cy="18.5" r="3.5" fill="#bae6fd" stroke="white" strokeWidth="1.5"/>
//               <path d="M18.5 17V20M17 18.5H20" stroke="#0c4a6e" strokeWidth="1.5" strokeLinecap="round"/>
//             </svg>
//           </div>
//         </div>

//         <h2 style={styles.title}>Doctor Login</h2>
//         <p style={styles.subtitle}>Trusted Medical Portal</p>

//         <form onSubmit={handleLogin} autoComplete="off">
//           {/* Mobile Field */}
//           <div style={styles.fieldGroup}>
//             <label style={styles.label} htmlFor="mobile-input">Mobile Number</label>
//             <div style={styles.inputWrap}>
//               <span style={styles.inputIcon}>
//                 <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
//                   <rect x="5" y="2" width="14" height="20" rx="3" stroke="#38bdf8" strokeWidth="2"/>
//                   <circle cx="12" cy="18" r="1" fill="#38bdf8"/>
//                 </svg>
//               </span>
//               <input
//                 id="mobile-input"
//                 type="tel"
//                 name="Mobile"
//                 value={user.Mobile}
//                 onChange={handleChange}
//                 placeholder="10-digit mobile number"
//                 maxLength={10}
//                 style={styles.input(focusedField === "Mobile")}
//                 onFocus={() => setFocusedField("Mobile")}
//                 onBlur={() => setFocusedField(null)}
//               />
//             </div>
//           </div>

//           {/* Password Field */}
//           <div style={styles.fieldGroup}>
//             <label style={styles.label} htmlFor="password-input">Password</label>
//             <div style={styles.inputWrap}>
//               <span style={styles.inputIcon}>
//                 <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
//                   <rect x="5" y="11" width="14" height="10" rx="2" stroke="#38bdf8" strokeWidth="2"/>
//                   <path d="M8 11V7a4 4 0 0 1 8 0v4" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round"/>
//                   <circle cx="12" cy="16" r="1.5" fill="#38bdf8"/>
//                 </svg>
//               </span>
//               <input
//                 id="password-input"
//                 type="password"
//                 name="Password"
//                 value={user.Password}
//                 onChange={handleChange}
//                 placeholder="Enter your password"
//                 style={styles.input(focusedField === "Password")}
//                 onFocus={() => setFocusedField("Password")}
//                 onBlur={() => setFocusedField(null)}
//               />
//             </div>
//           </div>

//           {/* Forgot Password */}
//           <button
//             type="button"
//             onClick={openForgot}
//             style={styles.forgotLink}
//           >
//             Forgot Password?
//           </button>

//           {/* Login Button */}
//           <button
//             type="submit"
//             disabled={loading}
//             style={styles.button}
//           >
//             {loading ? "Signing in…" : "Login"}
//           </button>
//         </form>

//         {/* Divider */}
//         <div style={styles.divider}>
//           <div style={styles.dividerLine} />
//           <span style={styles.dividerText}>OR</span>
//         </div>

//         {/* Register Button */}
//         <button
//           style={styles.registerBtn}
//           onClick={() => history.push("/doctor-register")}
//         >
//           Don't have an account? <span style={{ color: "#0ea5e9" }}>Register</span>
//         </button>

//         <div style={styles.footer}>
//           🔒 Secure & Encrypted Login
//         </div>
//       </div>

//       {/* ── Forgot Password Panel ───────────────────────────────────────── */}
//       {showForgot && (
//         <div style={styles.forgotOverlay} onMouseDown={closeForgot}>
//           <div style={styles.forgotCard} onMouseDown={(e) => e.stopPropagation()}>
//             {!forgotSent ? (
//               <>
//                 <div style={styles.forgotHeader}>
//                   <h3 style={styles.forgotTitle}>Reset Password</h3>
//                   <button style={styles.forgotClose} onClick={closeForgot} aria-label="Close">
//                     ✕
//                   </button>
//                 </div>
//                 <p style={styles.forgotDesc}>
//                   Enter your registered mobile number. We'll send a password
//                   reset link to the email linked to your account.
//                 </p>

//                 <form onSubmit={handleForgotPassword}>
//                   <div style={styles.fieldGroup}>
//                     <label style={styles.label} htmlFor="forgot-mobile-input">
//                       Mobile Number
//                     </label>
//                     <div style={styles.inputWrap}>
//                       <span style={styles.inputIcon}>
//                         <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
//                           <rect x="5" y="2" width="14" height="20" rx="3" stroke="#38bdf8" strokeWidth="2"/>
//                           <circle cx="12" cy="18" r="1" fill="#38bdf8"/>
//                         </svg>
//                       </span>
//                       <input
//                         id="forgot-mobile-input"
//                         type="tel"
//                         value={forgotMobile}
//                         onChange={(e) => setForgotMobile(e.target.value)}
//                         placeholder="10-digit mobile number"
//                         maxLength={10}
//                         autoFocus
//                         style={styles.input(forgotFocused)}
//                         onFocus={() => setForgotFocused(true)}
//                         onBlur={() => setForgotFocused(false)}
//                       />
//                     </div>
//                   </div>

//                   <button type="submit" disabled={forgotLoading} style={styles.forgotSubmitBtn}>
//                     {forgotLoading ? "Sending…" : "Send Reset Link"}
//                   </button>
//                 </form>
//               </>
//             ) : (
//               <div style={styles.forgotSuccessWrap}>
//                 <div style={styles.forgotSuccessIcon}>
//                   <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
//                     <path d="M5 13l4 4L19 7" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
//                   </svg>
//                 </div>
//                 <h3 style={{ ...styles.forgotTitle, marginBottom: 10 }}>Check Your Email</h3>
//                 <p style={styles.forgotSuccessText}>
//                   If that mobile number is registered, a password reset link
//                   has been sent to the email on file. Open it to set a new
//                   password, then come back here to log in.
//                 </p>
//                 <button style={styles.forgotDoneBtn} onClick={closeForgot}>
//                   Done
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default DrLogin;


import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { getDatabase, ref, get } from "firebase/database";
import {
  getAuth,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  verifyPasswordResetCode,
  confirmPasswordReset,
} from "firebase/auth";
import { toast, Toaster } from "react-hot-toast";
import { app } from "../Firebase/firebase.config";

const auth = getAuth(app);
const fireDB = getDatabase(app);

const DrLogin = () => {
  const history = useHistory();
  const [user, setUser] = useState({ Mobile: "", Password: "" });
  const [focusedField, setFocusedField] = useState(null);
  const [loading, setLoading] = useState(false);

  // ── Forgot Password state ──────────────────────────────────────────────
  const [showForgot, setShowForgot] = useState(false);
  const [forgotMobile, setForgotMobile] = useState("");
  const [forgotFocused, setForgotFocused] = useState(false);
  const [forgotLoading, setForgotLoading] = useState(false);
  const [forgotSent, setForgotSent] = useState(false);

  // ── Reset-completion state (when user arrives via the emailed link) ────
  const [resetMode, setResetMode] = useState(false);
  const [resetCode, setResetCode] = useState(null);
  const [resetEmail, setResetEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [resetVerifying, setResetVerifying] = useState(true);
  const [resetSubmitting, setResetSubmitting] = useState(false);
  const [resetError, setResetError] = useState("");
  const [resetDone, setResetDone] = useState(false);

  // Detect ?mode=resetPassword&oobCode=... on page load
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const mode = params.get("mode");
    const oobCode = params.get("oobCode");

    if (mode === "resetPassword" && oobCode) {
      setResetMode(true);
      verifyPasswordResetCode(auth, oobCode)
        .then((email) => {
          setResetCode(oobCode);
          setResetEmail(email);
          setResetVerifying(false);
        })
        .catch(() => {
          setResetError(
            "This reset link is invalid or has expired. Please request a new one."
          );
          setResetVerifying(false);
        });
    } else {
      setResetVerifying(false);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prev) => ({ ...prev, [name]: value }));
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    const { Mobile, Password } = user;

    if (!Mobile || !Password) {
      toast.error("Mobile and Password required");
      return;
    }
    if (!/^\d{10}$/.test(Mobile)) {
      toast.error("Invalid Mobile number");
      return;
    }

    setLoading(true);
    try {
      const snapshot = await get(ref(fireDB, "doctor"));
      if (!snapshot.exists()) {
        toast.error("No doctors found");
        setLoading(false);
        return;
      }

      let doctorFound = null;
      snapshot.forEach((doc) => {
        const data = doc.val();
        if (data.Mobile === Mobile) {
          doctorFound = { ...data, uid: doc.key };
        }
      });

      if (!doctorFound) {
        toast.error("Mobile not registered");
        setLoading(false);
        return;
      }

      await signInWithEmailAndPassword(auth, doctorFound.Email, Password);
      toast.success("Login successful!");
      history.replace(`/profile/${doctorFound.uid}`);
    } catch (error) {
      console.error(error);
      toast.error("Incorrect Mobile or Password");
    } finally {
      setLoading(false);
    }
  };

  // ── Forgot Password handler ────────────────────────────────────────────
  const handleForgotPassword = async (e) => {
    e.preventDefault();

    if (!forgotMobile) {
      toast.error("Please enter your registered mobile number");
      return;
    }
    if (!/^\d{10}$/.test(forgotMobile)) {
      toast.error("Invalid Mobile number");
      return;
    }

    setForgotLoading(true);
    try {
      const snapshot = await get(ref(fireDB, "doctor"));
      let doctorFound = null;

      if (snapshot.exists()) {
        snapshot.forEach((doc) => {
          const data = doc.val();
          if (data.Mobile === forgotMobile) {
            doctorFound = { ...data, uid: doc.key };
          }
        });
      }

      console.log("forgotMobile entered:", forgotMobile);
      console.log("doctorFound:", doctorFound);
      console.log("Mobile → Email mapping:", forgotMobile, "→", doctorFound?.Email ?? "No email found for this number");

      if (doctorFound?.Email) {
        const actionCodeSettings = {
          url: `${window.location.origin}/doctor-login`,
          handleCodeInApp: true,
        };
        await sendPasswordResetEmail(auth, doctorFound.Email, actionCodeSettings);
      }

      setForgotSent(true);
      toast.success(
        "If that mobile is registered, a reset link has been sent to the linked email."
      );
    } catch (error) {
      console.error(error);
      setForgotSent(true);
      toast.success(
        "If that mobile is registered, a reset link has been sent to the linked email."
      );
    } finally {
      setForgotLoading(false);
    }
  };

  // ── Reset-completion handler ───────────────────────────────────────────
  const handleResetSubmit = async (e) => {
    e.preventDefault();

    if (!newPassword || !confirmNewPassword) {
      toast.error("Please fill in both password fields");
      return;
    }
    if (newPassword.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    if (newPassword !== confirmNewPassword) {
      toast.error("Passwords do not match");
      return;
    }

    setResetSubmitting(true);
    try {
      await confirmPasswordReset(auth, resetCode, newPassword);
      setResetDone(true);
      toast.success("Password reset successfully! You can now log in.");
    } catch (error) {
      console.error(error);
      toast.error("Failed to reset password. The link may have expired.");
    } finally {
      setResetSubmitting(false);
    }
  };

  const openForgot = () => {
    setShowForgot(true);
    setForgotSent(false);
    setForgotMobile("");
  };

  const closeForgot = () => {
    setShowForgot(false);
    setForgotSent(false);
    setForgotMobile("");
  };

  const styles = {
    page: {
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(135deg, #e0f2fe 0%, #bae6fd 40%, #e0f7fa 100%)",
      fontFamily: "'Nunito', 'Segoe UI', sans-serif",
      padding: "16px",
    },
    card: {
      width: "100%",
      maxWidth: "420px",
      background: "rgba(255,255,255,0.85)",
      backdropFilter: "blur(16px)",
      borderRadius: "24px",
      boxShadow: "0 8px 40px rgba(14, 116, 144, 0.13), 0 2px 8px rgba(14,116,144,0.07)",
      padding: "40px 32px 36px",
      border: "1px solid rgba(186,230,253,0.6)",
    },
    iconWrap: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "20px",
    },
    iconCircle: {
      width: "64px",
      height: "64px",
      borderRadius: "50%",
      background: "linear-gradient(135deg, #0ea5e9 0%, #38bdf8 100%)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      boxShadow: "0 4px 16px rgba(14,165,233,0.30)",
    },
    title: {
      textAlign: "center",
      fontSize: "26px",
      fontWeight: "800",
      color: "#0c4a6e",
      margin: "0 0 4px",
      letterSpacing: "-0.5px",
    },
    subtitle: {
      textAlign: "center",
      fontSize: "14px",
      color: "#7dd3fc",
      marginBottom: "28px",
      fontWeight: "600",
      letterSpacing: "0.5px",
      textTransform: "uppercase",
    },
    fieldGroup: {
      marginBottom: "18px",
    },
    label: {
      display: "block",
      fontSize: "13px",
      fontWeight: "700",
      color: "#0369a1",
      marginBottom: "7px",
      letterSpacing: "0.3px",
    },
    inputWrap: {
      position: "relative",
      display: "flex",
      alignItems: "center",
    },
    inputIcon: {
      position: "absolute",
      left: "14px",
      top: "50%",
      transform: "translateY(-50%)",
      pointerEvents: "none",
      display: "flex",
      alignItems: "center",
    },
    input: (focused) => ({
      width: "100%",
      padding: "13px 14px 13px 44px",
      border: focused
        ? "2px solid #0ea5e9"
        : "2px solid #e0f2fe",
      borderRadius: "12px",
      fontSize: "15px",
      fontFamily: "'Nunito', 'Segoe UI', sans-serif",
      fontWeight: "600",
      color: "#0c4a6e",
      background: focused ? "#f0f9ff" : "#f8fdff",
      outline: "none",
      transition: "border 0.2s, background 0.2s, box-shadow 0.2s",
      boxShadow: focused ? "0 0 0 3px rgba(14,165,233,0.13)" : "none",
      boxSizing: "border-box",
    }),
    button: {
      width: "100%",
      padding: "14px",
      background: loading
        ? "#7dd3fc"
        : "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
      color: "#fff",
      border: "none",
      borderRadius: "12px",
      fontSize: "16px",
      fontWeight: "800",
      fontFamily: "'Nunito', 'Segoe UI', sans-serif",
      cursor: loading ? "not-allowed" : "pointer",
      boxShadow: "0 4px 16px rgba(14,165,233,0.30)",
      letterSpacing: "0.3px",
      marginTop: "6px",
      transition: "background 0.2s, transform 0.1s",
    },
    forgotLink: {
      display: "block",
      textAlign: "right",
      fontSize: "12.5px",
      fontWeight: "700",
      color: "#0ea5e9",
      background: "none",
      border: "none",
      cursor: "pointer",
      padding: "0 0 14px",
      marginTop: "-8px",
      letterSpacing: "0.2px",
    },
    divider: {
      textAlign: "center",
      margin: "22px 0 14px",
      position: "relative",
    },
    dividerLine: {
      borderTop: "1px solid #e0f2fe",
      width: "100%",
      position: "absolute",
      top: "50%",
      left: 0,
    },
    dividerText: {
      position: "relative",
      background: "rgba(255,255,255,0.85)",
      padding: "0 12px",
      color: "#93c5fd",
      fontSize: "12px",
      fontWeight: "700",
    },
    registerBtn: {
      display: "block",
      width: "100%",
      padding: "13px",
      background: "transparent",
      border: "2px solid #bae6fd",
      borderRadius: "12px",
      color: "#0284c7",
      fontSize: "15px",
      fontWeight: "700",
      fontFamily: "'Nunito', 'Segoe UI', sans-serif",
      cursor: "pointer",
      textAlign: "center",
      transition: "background 0.2s, border-color 0.2s",
      letterSpacing: "0.2px",
    },
    footer: {
      textAlign: "center",
      marginTop: "24px",
      fontSize: "12px",
      color: "#93c5fd",
      fontWeight: "600",
    },
    // ── Forgot Password panel ──
    forgotOverlay: {
      position: "fixed",
      top: 0, left: 0, right: 0, bottom: 0,
      background: "rgba(12, 74, 110, 0.45)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "16px",
      zIndex: 1000,
    },
    forgotCard: {
      width: "100%",
      maxWidth: "380px",
      background: "#ffffff",
      borderRadius: "20px",
      boxShadow: "0 12px 48px rgba(14, 116, 144, 0.25)",
      padding: "30px 26px 26px",
      border: "1px solid rgba(186,230,253,0.6)",
    },
    forgotHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "6px",
    },
    forgotTitle: {
      fontSize: "19px",
      fontWeight: "800",
      color: "#0c4a6e",
      margin: 0,
    },
    forgotClose: {
      background: "#f0f9ff",
      border: "none",
      borderRadius: "8px",
      width: "30px",
      height: "30px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      color: "#0369a1",
      fontSize: "16px",
      lineHeight: 1,
    },
    forgotDesc: {
      fontSize: "13px",
      color: "#64748b",
      margin: "0 0 20px",
      lineHeight: 1.5,
    },
    forgotSubmitBtn: {
      width: "100%",
      padding: "13px",
      background: forgotLoading
        ? "#7dd3fc"
        : "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
      color: "#fff",
      border: "none",
      borderRadius: "12px",
      fontSize: "15px",
      fontWeight: "800",
      fontFamily: "'Nunito', 'Segoe UI', sans-serif",
      cursor: forgotLoading ? "not-allowed" : "pointer",
      boxShadow: "0 4px 16px rgba(14,165,233,0.30)",
      marginTop: "4px",
    },
    forgotSuccessWrap: {
      textAlign: "center",
      padding: "8px 0 4px",
    },
    forgotSuccessIcon: {
      width: "56px",
      height: "56px",
      borderRadius: "50%",
      background: "#dcfce7",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      margin: "0 auto 14px",
    },
    forgotSuccessText: {
      fontSize: "14px",
      color: "#334155",
      lineHeight: 1.6,
      margin: "0 0 20px",
    },
    forgotDoneBtn: {
      width: "100%",
      padding: "12px",
      background: "#f0f9ff",
      border: "2px solid #bae6fd",
      borderRadius: "12px",
      color: "#0284c7",
      fontSize: "14px",
      fontWeight: "700",
      cursor: "pointer",
    },
  };

  // ── If the user arrived via the password-reset email link ─────────────
  if (resetMode) {
    return (
      <div style={styles.page}>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              fontFamily: "'Nunito', sans-serif",
              fontWeight: "700",
              borderRadius: "12px",
              fontSize: "14px",
            },
          }}
        />
        <div style={styles.card}>
          <div style={styles.iconWrap}>
            <div style={styles.iconCircle}>
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
                <rect x="5" y="11" width="14" height="10" rx="2" stroke="white" strokeWidth="2"/>
                <path d="M8 11V7a4 4 0 0 1 8 0v4" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                <circle cx="12" cy="16" r="1.5" fill="white"/>
              </svg>
            </div>
          </div>

          <h2 style={styles.title}>Reset Password</h2>
          <p style={styles.subtitle}>Trusted Medical Portal</p>

          {resetVerifying ? (
            <p style={{ textAlign: "center", color: "#64748b" }}>
              Verifying your reset link…
            </p>
          ) : resetError ? (
            <>
              <p style={{ textAlign: "center", color: "#dc2626", marginBottom: 20, lineHeight: 1.6 }}>
                {resetError}
              </p>
              <button
                style={styles.registerBtn}
                onClick={() => history.push("/doctor-login")}
              >
                Back to Login
              </button>
            </>
          ) : resetDone ? (
            <div style={styles.forgotSuccessWrap}>
              <div style={styles.forgotSuccessIcon}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <path d="M5 13l4 4L19 7" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <p style={styles.forgotSuccessText}>
                Your password has been reset successfully. You can now log
                in with your new password.
              </p>
              <button
                style={styles.forgotDoneBtn}
                onClick={() => history.push("/doctor-login")}
              >
                Go to Login
              </button>
            </div>
          ) : (
            <form onSubmit={handleResetSubmit}>
              <p
                style={{
                  textAlign: "center",
                  fontSize: 13,
                  color: "#64748b",
                  marginBottom: 18,
                  lineHeight: 1.5,
                }}
              >
                Resetting password for <strong>{resetEmail}</strong>
              </p>

              <div style={styles.fieldGroup}>
                <label style={styles.label} htmlFor="new-password-input">
                  New Password
                </label>
                <div style={styles.inputWrap}>
                  <span style={styles.inputIcon}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <rect x="5" y="11" width="14" height="10" rx="2" stroke="#38bdf8" strokeWidth="2"/>
                      <path d="M8 11V7a4 4 0 0 1 8 0v4" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round"/>
                      <circle cx="12" cy="16" r="1.5" fill="#38bdf8"/>
                    </svg>
                  </span>
                  <input
                    id="new-password-input"
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    placeholder="Enter new password"
                    style={styles.input(false)}
                  />
                </div>
              </div>

              <div style={styles.fieldGroup}>
                <label style={styles.label} htmlFor="confirm-password-input">
                  Confirm Password
                </label>
                <div style={styles.inputWrap}>
                  <span style={styles.inputIcon}>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <rect x="5" y="11" width="14" height="10" rx="2" stroke="#38bdf8" strokeWidth="2"/>
                      <path d="M8 11V7a4 4 0 0 1 8 0v4" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round"/>
                      <circle cx="12" cy="16" r="1.5" fill="#38bdf8"/>
                    </svg>
                  </span>
                  <input
                    id="confirm-password-input"
                    type="password"
                    value={confirmNewPassword}
                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                    placeholder="Confirm new password"
                    style={styles.input(false)}
                  />
                </div>
              </div>

              <button type="submit" disabled={resetSubmitting} style={styles.button}>
                {resetSubmitting ? "Resetting…" : "Reset Password"}
              </button>
            </form>
          )}
        </div>
      </div>
    );
  }

  return (
    <div style={styles.page}>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            fontFamily: "'Nunito', sans-serif",
            fontWeight: "700",
            borderRadius: "12px",
            fontSize: "14px",
          },
        }}
      />

      <div style={styles.card}>
        {/* Icon */}
        <div style={styles.iconWrap}>
          <div style={styles.iconCircle}>
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
              <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" fill="white"/>
              <path d="M3 21C3 17.134 7.02944 14 12 14C16.9706 14 21 17.134 21 21" stroke="white" strokeWidth="2" strokeLinecap="round"/>
              <circle cx="18.5" cy="18.5" r="3.5" fill="#bae6fd" stroke="white" strokeWidth="1.5"/>
              <path d="M18.5 17V20M17 18.5H20" stroke="#0c4a6e" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </div>
        </div>

        <h2 style={styles.title}>Doctor Login</h2>
        <p style={styles.subtitle}>Trusted Medical Portal</p>

        <form onSubmit={handleLogin} autoComplete="off">
          {/* Mobile Field */}
          <div style={styles.fieldGroup}>
            <label style={styles.label} htmlFor="mobile-input">Mobile Number</label>
            <div style={styles.inputWrap}>
              <span style={styles.inputIcon}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <rect x="5" y="2" width="14" height="20" rx="3" stroke="#38bdf8" strokeWidth="2"/>
                  <circle cx="12" cy="18" r="1" fill="#38bdf8"/>
                </svg>
              </span>
              <input
                id="mobile-input"
                type="tel"
                name="Mobile"
                value={user.Mobile}
                onChange={handleChange}
                placeholder="10-digit mobile number"
                maxLength={10}
                style={styles.input(focusedField === "Mobile")}
                onFocus={() => setFocusedField("Mobile")}
                onBlur={() => setFocusedField(null)}
              />
            </div>
          </div>

          {/* Password Field */}
          <div style={styles.fieldGroup}>
            <label style={styles.label} htmlFor="password-input">Password</label>
            <div style={styles.inputWrap}>
              <span style={styles.inputIcon}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <rect x="5" y="11" width="14" height="10" rx="2" stroke="#38bdf8" strokeWidth="2"/>
                  <path d="M8 11V7a4 4 0 0 1 8 0v4" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round"/>
                  <circle cx="12" cy="16" r="1.5" fill="#38bdf8"/>
                </svg>
              </span>
              <input
                id="password-input"
                type="password"
                name="Password"
                value={user.Password}
                onChange={handleChange}
                placeholder="Enter your password"
                style={styles.input(focusedField === "Password")}
                onFocus={() => setFocusedField("Password")}
                onBlur={() => setFocusedField(null)}
              />
            </div>
          </div>

          {/* Forgot Password */}
          <button
            type="button"
            onClick={openForgot}
            style={styles.forgotLink}
          >
            Forgot Password?
          </button>

          {/* Login Button */}
          <button
            type="submit"
            disabled={loading}
            style={styles.button}
          >
            {loading ? "Signing in…" : "Login"}
          </button>
        </form>

        {/* Divider */}
        <div style={styles.divider}>
          <div style={styles.dividerLine} />
          <span style={styles.dividerText}>OR</span>
        </div>

        {/* Register Button */}
        <button
          style={styles.registerBtn}
          onClick={() => history.push("/doctor-register")}
        >
          Don't have an account? <span style={{ color: "#0ea5e9" }}>Register</span>
        </button>

        <div style={styles.footer}>
          🔒 Secure & Encrypted Login
        </div>
      </div>

      {/* ── Forgot Password Panel ───────────────────────────────────────── */}
      {showForgot && (
        <div style={styles.forgotOverlay} onMouseDown={closeForgot}>
          <div style={styles.forgotCard} onMouseDown={(e) => e.stopPropagation()}>
            {!forgotSent ? (
              <>
                <div style={styles.forgotHeader}>
                  <h3 style={styles.forgotTitle}>Reset Password</h3>
                  <button style={styles.forgotClose} onClick={closeForgot} aria-label="Close">
                    ✕
                  </button>
                </div>
                <p style={styles.forgotDesc}>
                  Enter your registered mobile number. We'll send a password
                  reset link to the email linked to your account.
                </p>

                <form onSubmit={handleForgotPassword}>
                  <div style={styles.fieldGroup}>
                    <label style={styles.label} htmlFor="forgot-mobile-input">
                      Mobile Number
                    </label>
                    <div style={styles.inputWrap}>
                      <span style={styles.inputIcon}>
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                          <rect x="5" y="2" width="14" height="20" rx="3" stroke="#38bdf8" strokeWidth="2"/>
                          <circle cx="12" cy="18" r="1" fill="#38bdf8"/>
                        </svg>
                      </span>
                      <input
                        id="forgot-mobile-input"
                        type="tel"
                        value={forgotMobile}
                        onChange={(e) => setForgotMobile(e.target.value)}
                        placeholder="10-digit mobile number"
                        maxLength={10}
                        autoFocus
                        style={styles.input(forgotFocused)}
                        onFocus={() => setForgotFocused(true)}
                        onBlur={() => setForgotFocused(false)}
                      />
                    </div>
                  </div>

                  <button type="submit" disabled={forgotLoading} style={styles.forgotSubmitBtn}>
                    {forgotLoading ? "Sending…" : "Send Reset Link"}
                  </button>
                </form>
              </>
            ) : (
              <div style={styles.forgotSuccessWrap}>
                <div style={styles.forgotSuccessIcon}>
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                    <path d="M5 13l4 4L19 7" stroke="#16a34a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h3 style={{ ...styles.forgotTitle, marginBottom: 10 }}>Check Your Email</h3>
                <p style={styles.forgotSuccessText}>
                  If that mobile number is registered, a password reset link
                  has been sent to the email on file. Open it to set a new
                  password, then come back here to log in.
                </p>
                <button style={styles.forgotDoneBtn} onClick={closeForgot}>
                  Done
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DrLogin;